import { HashRouter as Router, Routes, Route } from 'react-router-dom'
import NotFound from 'pages/NotFound/NotFound'
import Home from 'pages/Home/Home'
import Clt from 'pages/Clt/Clt'

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/consignado-clt' element={<Clt />} />
        <Route path='*' element={<NotFound />} />
      </Routes>
    </Router>
  )
}
